// String-based test mode for readability and API clarity
export type PaymentAuthTestMode = 'none' | 'dry-run-success' | 'dry-run-failed';

// Optional helper constants for usage in apps
export const PaymentAuthTestModes = {
  None: 'none' as PaymentAuthTestMode,
  DryRunSuccess: 'dry-run-success' as PaymentAuthTestMode,
  DryRunFailed: 'dry-run-failed' as PaymentAuthTestMode,
};
